import { render, staticRenderFns } from "./zcsxEntry.vue?vue&type=template&id=1313c2ba&scoped=true&"
import script from "./zcsxEntry.vue?vue&type=script&lang=js&"
export * from "./zcsxEntry.vue?vue&type=script&lang=js&"
import style0 from "./zcsxEntry.vue?vue&type=style&index=0&id=1313c2ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313c2ba",
  null
  
)

export default component.exports